import unit from './unit';

export default function percent(value, decimals = 2) {
  return unit(value, '%', decimals);
}
